import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Web3 from 'web3';
import LoaderHelper from "../../../Services/Loading/LoaderHelper";
import { onboard } from "../../../lib/WalletCoonect";
import { alertErrorMessage, alertSuccessMessage } from "../../CoustamComponent/CustomMessage";
import AuthService from "../../../Services/AuthAction/AuthService";

const BuyCoin = () => {

    const location = useLocation();
    const { state } = location;
    const [firmName, setFirmName] = useState('')
    const [website, setWebsite] = useState('')
    const [structure, setStructure] = useState('DAO')
    const [other, setOther] = useState('')
    const [city, setCity] = useState('')
    const [zipCode, setZipCode] = useState('')
    const [country, setCountry] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [tittle, setTittle] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [recivedData, setRecivedData] = useState('')
    const [currency, setCurrency] = useState('')
    const navigate = useNavigate();
    const [resultSuccess, setResultSuccess] = useState(false);

    const USDT = '0x7b504F0C6C7958ca1b00d4C3B87C93a6Ae52deF0';   // testnet
    const USDC = '0x5a080F8CE8fDCFa3d6C47375BA010F03f669ad28';  // testnet
    const tokenSale = '0xDE9C463074bE18D57dD5AFD4D439321D8A26ee3e';  // testnet

    const countryList = require('country-list');
    const countries = countryList.getNames();

    const ERC20TransferABI = [{ "inputs": [], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "burn", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "burnFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "mint", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "renounceOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }]

    const TokenSaleABI = [{ "inputs": [], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "_user", "type": "address" }, { "indexed": true, "internalType": "uint256", "name": "_amount", "type": "uint256" }], "name": "TokenBought", "type": "event" }, { "inputs": [], "name": "USDC", "outputs": [{ "internalType": "contract ERC20", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "USDT", "outputs": [{ "internalType": "contract ERC20", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "receiver", "type": "address" }], "name": "buyTokenForFirstChoiceUSDC", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "receiver", "type": "address" }], "name": "buyTokenForFirstChoiceUSDT", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "receiver", "type": "address" }], "name": "buyTokenForSecondChoiceUSDC", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "receiver", "type": "address" }], "name": "buyTokenForSecondChoiceUSDT", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "receiver", "type": "address" }], "name": "buyTokenForThirdChoiceUSDC", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "receiver", "type": "address" }], "name": "buyTokenForThirdChoiceUSDT", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "s_amountRaisedUSDC", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "s_amountRaisedUSDT", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "s_firstChoiceDollarBuy", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "s_owner", "outputs": [{ "internalType": "address payable", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "s_preSaleStartTime", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "s_presaleStatus", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "s_secondChoiceDollarBuy", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "s_soldToken", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "s_thirdChoiceDollarBuy", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "s_tokenPerUsdForFirstChoice", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "s_tokenPerUsdForSecondChoice", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "s_tokenPerUsdForThirdChoice", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "s_tokensOnSale", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "stopSale", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "token", "outputs": [{ "internalType": "contract ERC20", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "users", "outputs": [{ "internalType": "uint256", "name": "s_usdt_spend", "type": "uint256" }, { "internalType": "uint256", "name": "s_usdc_spend", "type": "uint256" }, { "internalType": "uint256", "name": "s_token_balance", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "withdrawTokens", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "withdrawUSDC", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "withdrawUSDT", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "stateMutability": "payable", "type": "receive" }];

    const targetDate = new Date(recivedData?.expiresOn).getTime();
    const now = new Date().getTime();
    const timeRemaining = targetDate - now;

    const [countdown, setCountdown] = useState(timeRemaining);
    const [walletData, setWalletData] = useState('');


    useEffect(() => {
        if (resultSuccess) {
            const interval = setInterval(() => {
                const now = new Date().getTime();
                const updatedCountdown = Math.max(0, targetDate - now);
                setCountdown(updatedCountdown);
            }, 1000);

            return () => clearInterval(interval);
        }

    }, [targetDate, resultSuccess]);


    const formatTime = (time) => {
        const days = Math.floor(time / (1000 * 60 * 60 * 24));
        const hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((time % (1000 * 60)) / 1000);

        return `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`;
    };

    const [web3Connected, setWeb3] = useState('');


    useEffect(() => {
        {
            if (walletData) {
                const web3Connected = new Web3(window.ethereum);
                setWeb3(web3Connected)
            }
        }
    }, [walletData]);


    const connectWallet = async () => {
        const wallets = await onboard.connectWallet()
        setWalletData(wallets[0]?.accounts?.[0]?.address);
    }

    const handleBuyCoin = async (currency, firmName, website, structure, other, city, country, firstName, lastName, tittle, email, phone, zipCode) => {
        if (!walletData) {
            connectWallet();
        } else if (!currency) {
            alertErrorMessage('Please Select Currency Name')
        } else if (!firmName) {
            alertErrorMessage('Please Enter Firm Name')
        } else if (!website) {
            alertErrorMessage('Please Enter website Address')
        } else if (!structure) {
            alertErrorMessage('Please Select OrganizaLonal Structure')
        } else if (!other) {
            alertErrorMessage('Please Enter Company Mailing Address')
        } else if (!city) {
            alertErrorMessage('Please Enter City Name')
        }
        else if (!zipCode) {
            alertErrorMessage('Please Enter Zip Code')
        }
        else if (!country) {
            alertErrorMessage('Please Select Country Name')
        } else if (!firstName) {
            alertErrorMessage('Please Enter First Name')
        } else if (!lastName) {
            alertErrorMessage('Please Enter Last Name')
        } else if (!tittle) {
            alertErrorMessage('Please Enter Tittle Name')
        } else if (!email) {
            alertErrorMessage('Please Enter Email Address')
        } else if (!phone) {
            alertErrorMessage('Please Enter Phone Number')
        }
        else {
            const accounts = await web3Connected.eth.getAccounts();
            const UsdtInstance = new web3Connected.eth.Contract(ERC20TransferABI, USDT)
            const UsdcInstance = new web3Connected.eth.Contract(ERC20TransferABI, USDC);
            const TokenSaleInstance = new web3Connected.eth.Contract(TokenSaleABI, tokenSale);
            let reciverAddress = accounts[0];
            if (state.trade_price == 0.47) {
                console.log("First Choice..");
                const amountToApproveFirst = 47000000000;
                if (currency === 'USDT') {
                    console.log('First choice with currency USDT')
                    try {
                        LoaderHelper.loaderStatus(true);
                        await UsdtInstance.methods.approve(tokenSale, amountToApproveFirst).send({
                            from: accounts[0],
                        });
                        await TokenSaleInstance.methods.buyTokenForFirstChoiceUSDT(reciverAddress).send({
                            from: accounts[0],
                        })
                        await AuthService.submitBuyDetails(currency, firmName, website, structure, other, city, country, firstName, lastName, tittle, email, phone, zipCode, walletData).then(async (result) => {
                            if (result.success) {
                                LoaderHelper.loaderStatus(false);
                                try {
                                    alertSuccessMessage('Tokens purchased successfully');
                                    navigate('/')
                                } catch (error) {
                                    alertErrorMessage(error);
                                }
                            } else {
                                LoaderHelper.loaderStatus(false);
                                alertErrorMessage(result.message);
                            }
                        });
                    } catch (error) {
                        alertErrorMessage(error.message);
                        LoaderHelper.loaderStatus(false);
                    }
                }
                if (currency === 'USDC') {
                    console.log('First choice with currenct USDC')
                    try {
                        LoaderHelper.loaderStatus(true);
                        await UsdcInstance.methods.approve(tokenSale, amountToApproveFirst).send({
                            from: accounts[0],
                        })
                        await TokenSaleInstance.methods.buyTokenForFirstChoiceUSDC(reciverAddress).send({
                            from: accounts[0],
                        })
                        await AuthService.submitBuyDetails(currency, firmName, website, structure, other, city, country, firstName, lastName, tittle, email, phone, zipCode, walletData).then(async (result) => {
                            if (result.success) {
                                LoaderHelper.loaderStatus(false);
                                try {
                                    alertSuccessMessage('Tokens purchased successfully');
                                    navigate('/')
                                } catch (error) {
                                    alertErrorMessage(error);
                                }
                            } else {
                                LoaderHelper.loaderStatus(false);
                                alertErrorMessage(result.message);
                            }
                        });
                    } catch (error) {
                        console.log(error.message);
                        alertErrorMessage(error.message);
                        LoaderHelper.loaderStatus(false);
                    }
                }
            } else if (state?.trade_price == 0.4230) {
                console.log("Second Choice..");
                const amountToApproveSecond = 100000000000;
                if (currency === 'USDT') {
                    console.log('Second choice with currency USDT')
                    try {
                        LoaderHelper.loaderStatus(true);
                        await UsdtInstance.methods.approve(tokenSale, amountToApproveSecond).send({
                            from: accounts[0],
                        })
                        await TokenSaleInstance.methods.buyTokenForSecondChoiceUSDT(reciverAddress).send({
                            from: accounts[0],
                        })
                        await AuthService.submitBuyDetails(currency, firmName, website, structure, other, city, country, firstName, lastName, tittle, email, phone, zipCode, walletData).then(async (result) => {
                            if (result.success) {
                                LoaderHelper.loaderStatus(false);
                                try {
                                    alertSuccessMessage('Tokens purchased successfully');
                                    navigate('/')
                                } catch (error) {
                                    alertErrorMessage(error);
                                }
                            } else {
                                LoaderHelper.loaderStatus(false);
                                alertErrorMessage(result.message);
                            }
                        });
                    } catch (error) {
                        console.log(error.message);
                        alertErrorMessage(error.message);
                        LoaderHelper.loaderStatus(false);
                    }
                }
                if (currency === 'USDC') {
                    console.log('Second choice with currenct USDC')
                    try {
                        LoaderHelper.loaderStatus(true);
                        await UsdcInstance.methods.approve(tokenSale, amountToApproveSecond).send({
                            from: accounts[0],
                        })
                        await TokenSaleInstance.methods.buyTokenForSecondChoiceUSDC(reciverAddress).send({
                            from: accounts[0],
                        })
                        await AuthService.submitBuyDetails(currency, firmName, website, structure, other, city, country, firstName, lastName, tittle, email, phone, zipCode, walletData).then(async (result) => {
                            if (result.success) {
                                LoaderHelper.loaderStatus(false);
                                try {
                                    alertSuccessMessage('Tokens purchased successfully');
                                    navigate('/')
                                } catch (error) {
                                    alertErrorMessage(error);
                                }
                            } else {
                                LoaderHelper.loaderStatus(false);
                                alertErrorMessage(result.message);
                            }
                        });
                    } catch (error) {
                        console.log(error.message);
                        alertErrorMessage(error.message);
                        LoaderHelper.loaderStatus(false);
                    }
                }
            } else if (state?.trade_price == 0.3995) {
                console.log("Third Choice..");
                const amountToApproveThird = 250000000000;
                if (currency === 'USDT') {
                    console.log('Third choice with currency USDT')
                    try {
                        LoaderHelper.loaderStatus(true);
                        await UsdtInstance.methods.approve(tokenSale, amountToApproveThird).send({
                            from: accounts[0],
                        })
                        await TokenSaleInstance.methods.buyTokenForThirdChoiceUSDT(reciverAddress).send({
                            from: accounts[0],
                        })
                        await AuthService.submitBuyDetails(currency, firmName, website, structure, other, city, country, firstName, lastName, tittle, email, phone, zipCode, walletData).then(async (result) => {
                            if (result.success) {
                                LoaderHelper.loaderStatus(false);
                                try {
                                    alertSuccessMessage('Tokens purchased successfully');
                                    navigate('/')
                                } catch (error) {
                                    alertErrorMessage(error);
                                }
                            } else {
                                LoaderHelper.loaderStatus(false);
                                alertErrorMessage(result.message);
                            }
                        });
                    } catch (error) {
                        console.log(error.message);
                        alertErrorMessage(error.message);
                        LoaderHelper.loaderStatus(false);
                    }
                }
                if (currency === 'USDC') {
                    console.log('Third choice with currenct USDC')
                    try {
                        LoaderHelper.loaderStatus(true);
                        await UsdcInstance.methods.approve(tokenSale, amountToApproveThird).send({
                            from: accounts[0],
                        })
                        await TokenSaleInstance.methods.buyTokenForThirdChoiceUSDC(reciverAddress).send({
                            from: accounts[0],
                        })
                        await AuthService.submitBuyDetails(currency, firmName, website, structure, other, city, country, firstName, lastName, tittle, email, phone, zipCode, walletData).then(async (result) => {
                            if (result.success) {
                                LoaderHelper.loaderStatus(false);
                                try {
                                    alertSuccessMessage('Tokens purchased successfully');
                                    navigate('/')
                                } catch (error) {
                                    alertErrorMessage(error);
                                }
                            } else {
                                LoaderHelper.loaderStatus(false);
                                alertErrorMessage(result.message);
                            }
                        });
                    } catch (error) {
                        LoaderHelper.loaderStatus(false);
                        console.log(error.message);
                        alertErrorMessage(error.message);
                    }
                }
            }

        }
    };

    const copyToClipboard = (selectedAddress) => {
        if (selectedAddress) {
            const successMessage = selectedAddress + " " + 'Copied...';
            alertSuccessMessage(successMessage)
            navigator.clipboard.writeText(selectedAddress)
        }
    };



    console.log(country, '=======country');

    return (
        <section id="her_sec" className="section main_sec overflow-hidden">
            <div className="container container-xl z-2">
                {!resultSuccess ? (
                    <div className="step_1" >
                        <div className="row pt-7 pb-5 justify-content-center">
                            <div className="col-xl-7 col-lg-12 m-auto">
                                <div className="card">
                                    <div className="card-body p-md-4 " >
                                        <h3 className="text-center" > Buy <span className="text-gradient" >eSg Coin </span> </h3>
                                        <div className=" dropdown_menu_custom show p-2 mt-3"  >
                                            <div className="dd_link bg_light_gyay1"  >
                                                <div className="row g-4" >
                                                    <div className="col-6 col-lg-4" >
                                                        <h6 className=" mb-md-0">
                                                            <small>Volume</small>
                                                            {state?.volume}
                                                        </h6>
                                                    </div>
                                                    <div className="col-6 col-lg-4" >
                                                        <h6 className=" mb-md-0">
                                                            <small>Trade Price</small>
                                                            ${state?.trade_price}
                                                        </h6>
                                                    </div>
                                                    <div className="col-6 col-lg-4" >
                                                        <h6 className="mb-0 mb-md-0" >
                                                            <small> Amount Due </small>
                                                            ${state?.dueAmount} USD
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <form className="mt-4 custom_buy">
                                            <div className="form-group">
                                                <label htmlFor="emailInputIcon2">Select Currency:</label>
                                                <select className="form-select form-control" value={currency} onChange={(e) => setCurrency(e.target.value)} >
                                                    <option selected>Select Currency Name</option>
                                                    <option value="USDT">USDT</option>
                                                    <option value="USDC">USDC</option>
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="nameInputIcon2">Firm Name </label>
                                                <input className="form-control" placeholder="Firm Name" type="text" value={firmName} onChange={(e) => setFirmName(e.target.value)} />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="emailInputIcon2">Website</label>
                                                <input className="form-control" placeholder="URL" type="text" value={website} onChange={(e) => setWebsite(e.target.value)} />

                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="emailInputIcon2">Organizational Structure:</label>
                                                <select className="form-select form-control" value={structure} onChange={(e) => setStructure(e.target.value)} >
                                                    <option disabled>Please Select One </option>
                                                    <option value="DAO">DAO</option>
                                                    <option value="LLC">LLC</option>
                                                    <option value="S Corp">S Corp</option>
                                                    <option value="C Corp">C Corp</option>
                                                    <option value="Trust">Trust</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="emailInputIcon2">Company Mailing Address</label>
                                                <input className="form-control" placeholder="Enter Address" type="text" value={other} onChange={(e) => setOther(e.target.value)} />
                                            </div>

                                            <div className="row" >
                                                <div className="form-group col-lg-6">
                                                    <label htmlFor="emailInputIcon2"> City </label>
                                                    <input className="form-control" placeholder="Enter City" type="text" value={city} onChange={(e) => setCity(e.target.value)} />
                                                </div>
                                                <div className="fform-group col-lg-6">
                                                    <label htmlFor="emailInputIcon2">Zip Code</label>
                                                    <input className="form-control" placeholder="Enter Zip Code" type="text" value={zipCode} onChange={(e) => setZipCode(e.target.value)} />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="emailInputIcon2">Enter Country </label>
                                                <select className="form-select form-control" value={country} onChange={(e) => setCountry(e.target.value)}>
                                                    {countries ? (
                                                        <>
                                                            <option key="default">Please Select One</option>
                                                            <hr/>
                                                            <option key="United States of America" value="United States of America">
                                                                United States of America
                                                            </option>
                                                            {countries.map((item, index) => (
                                                                <option key={index} value={item}>
                                                                    {item}
                                                                </option>
                                                            ))}
                                                        </>
                                                    ) : null}
                                                </select>
                                            </div>

                                            <div className="row" >
                                                <div className="form-group col-lg-6">
                                                    <label htmlFor="emailInputIcon2"> First Name </label>
                                                    <input className="form-control" placeholder="Enter First Name" type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                                </div>
                                                <div className="form-group col-lg-6">
                                                    <label htmlFor="emailInputIcon2"> Last Name </label>
                                                    <input className="form-control" placeholder="Enter Last Name" type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="emailInputIcon2"> Title </label>
                                                <input className="form-control" placeholder="Enter Title" type="text" value={tittle} onChange={(e) => setTittle(e.target.value)} />
                                            </div>
                                            <div className="row" >
                                                <div className="form-group  col-lg-6">
                                                    <label htmlFor="emailInputIcon2"> Email </label>
                                                    <input className="form-control" placeholder="Enter Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                                </div>
                                                <div className="form-group col-lg-6">
                                                    <label htmlFor="emailInputIcon2"> Phone </label>
                                                    <input className="form-control" placeholder="Enter Phone" type="text" value={phone} onChange={(e) => setPhone(e.target.value)} />
                                                </div>
                                            </div>
                                        </form>
                                        <div className="mt-4 ">
                                            <button type="submit" className="btn btn-primary  btn-success btn-block" onClick={() => handleBuyCoin(currency, firmName, website, structure, other, city, country, firstName, lastName, tittle, email, phone, zipCode)}>{!walletData ? 'Connect Wallet' : 'Buy Coin'}</button>
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>
                ) : (
                    <div className="step_2" >
                        <div className="row pt-5 pb-5 justify-content-center" >
                            <div className="col-xl-5 col-lg-8 m-auto" >
                                <div className="card" >
                                    <div className="card-body p-md-4 " >
                                        <div className="dropdown_menu_custom show p-2 mb-3 text-center " >
                                            <div className=" pt-3 pb-2" >
                                                <p className="mb-0 h5"> Please deposit {recivedData?.amount?.amount} {recivedData?.amount?.currency} on {recivedData?.paymentMethods?.[0]?.chain} chain </p>
                                                <small> Pay before:  {formatTime(countdown)} </small>
                                            </div>
                                        </div>
                                        <img src={`https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=${recivedData?.paymentMethods?.[0]?.address}&choe=UTF-8`} className="img-fluid qr_img w-100" />
                                        <div className="form-group mt-3" >
                                            <input type="text" readonly="readonly" className="form-control " value={recivedData?.paymentMethods?.[0]?.address} onClick={() => copyToClipboard(recivedData?.paymentMethods?.[0]?.address)} style={{ cursor: 'pointer' }} />
                                        </div>
                                        <div className="text-center mt-3" ><small>Click above to copy code</small></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}



            </div>
        </section>
    )
}

export default BuyCoin